import { render, staticRenderFns } from "./EditService.vue?vue&type=template&id=b6a359b8&"
import script from "./EditService.vue?vue&type=script&lang=js&"
export * from "./EditService.vue?vue&type=script&lang=js&"
import style0 from "./EditService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports